export default __webpack_public_path__ + "static/media/Blog_title_img.7a5dad95.svg";